import React from "react";
import { getRemoteValue } from "@microdoing/shared/services/firebase";
import AllowNotificationsCardScreen from "./AllowNotificationsCardScreen";
import AllowNotificationsBellScreen from "./AllowNotificationsBellScreen";

interface Props {
  navigation: any;
  route: any;
}

const AllowNotificationsScreen = ({ navigation, route }: Props) => {
  // const experiment = getRemoteValue(
  //   "allow_notifications_card_screen",
  // )?.asBoolean();

  // if (experiment) {
  return <AllowNotificationsCardScreen navigation={navigation} route={route} />;
  // }
  return <AllowNotificationsBellScreen navigation={navigation} route={route} />;
};

export default AllowNotificationsScreen;
